var common = require("../utiles/common")

module.exports = {
    register: function () {
        document.createElement('head-title')
        ko.components.register('head-title', {
            viewModel: function (params) {
               var $this=this;
               $this.title=params.title;
               $this.btnText = params.btnText?params.btnText:null;
            },
            template: require("./HeadTitle.html")
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/template/HeadTitle.js
// module id = 97
// module chunks = 0